import { Drawer, Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Button, Input, Modal, SelectBox, Text, TextArea } from "sunrise-ui";
import { getAllMasterType } from "../../redux/reducers";
import {
  postCreateMachineData,
  getAllMachineData,
  getMachineData,
  putMachineData,
  deleteMachineData,
} from "../../redux/reducers/machineReducers";
import { AppDispatch } from "../../redux/store";
import ImageInputComponent from "../../utilities/ImageInputComponent";
import Loader from "../../utilities/Loader";
import EnlargeImage from "../Users/EnlargeImage";
import AddMachineDrawer from "./AddMachineDrawer";
import List from "./List";
import "./MachineCard.scss";

const AddMachine = () => {
  const dispatch = useDispatch<AppDispatch>();

  const initialFormState = {
    machineNumber: "",
    machineNumberErr: false,
    machineId: "",
    machineIdErr: false,
    machineType: "",
    machineTypeErr: false,
    machineStatus: "",
    machineStatusErr: false,
    ownerName: "",
    ownerNameErr: false,
    purchaseDate: "",
    purchaseDateErr: false,
    fuelConsumption: "",
    fuelConsumptionErr: false,
    rcNumber: "",
    // rcNumberErr: false,
    rcIssueDate: "",
    // rcIssueDateErr: false,
    rcExpiryDate: "",
    rcExpiryDateErr: false,
    rcExpiryDateErrMsg: "",
    tpiNumber: "",
    tpiNumberErr: false,
    tpiIssueDate: "",
    tpiIssueDateErr: false,
    tpiExpiryDate: "",
    tpiExpiryDateErr: false,
    tpiExpiryDateErrMsg: "",
    insuranceNumber: "",
    insuranceNumberErr: false,
    insuranceIssueDate: "",
    insuranceIssueDateErr: false,
    insuranceExpiryDate: "",
    insuranceExpiryDateErr: false,
    insuranceExpiryDateErrMsg: "",
    PUCNumber: "",
    // PUCNumberErr: false,
    PUCIssueDate: "",
    // PUCIssueDateErr: false,
    PUCExpiryDate: "",
    PUCExpiryDateErr: false,
    PUCExpiryDateErrMsg: "",
    description: "",
  };

  const [dataToDownload, setDataToDownload] = React.useState([]);
  const actionButtons = function (obj: any) {
    return (
      <Grid className="action_buttons_box d-flex v-center">
        <Button
          type="button"
          size="medium"
          isRounded={true}
          category="primary"
          onClick={() => {
            handleEdit(obj);
          }}
          className="mr-1 f14"
        >
          Edit
        </Button>
        <Button
          type="button"
          size="medium"
          isRounded={true}
          category="warning"
          onClick={() => {
            handleDelete(obj);
          }}
          className="mr-1 f14"
        >
          Remove
        </Button>
      </Grid>
    );
  };

  const checkExpiredDate = function (dateString: string) {
    const expiryDate:any = new Date(dateString);
    const today = new Date();
    const month = expiryDate.toLocaleString("default", { month: "short" });
    const day = `0${expiryDate.getDate()}`.slice(-2);
    if(expiryDate==="Invalid Date"){
      return ""
    }
    if (expiryDate < today) {
      return (
        <span
          style={{ color: "#961b01" }}
        >{`${day} ${month}, ${expiryDate.getFullYear()}`}</span>
      );
    }
    return <span>{`${day} ${month}, ${expiryDate.getFullYear()}`}</span>;
  };
  const fields = [
    { header: "Added On", value: "addedOn", format: "date" },
    { header: "Machine Detail", value: "machineDetail", search: true },
    { header: "Machine Type", value: "type", search: true },
    { header: "Machine ID", value: "machineId", search: true },
    { header: "Machine Number", value: "number", search: true },
    { header: "Machine Status", value: "ownership", search: true },
    { header: "Owner Name", value: "owner", search: true },
    {
      header: "Purchase/Rented Date",
      value: "purchasedOrRentedOn",
      format: "date",
    },
    {
      header: "Standard Fuel Consumption (Ltr/Hr)",
      value: "fuelConsumption",
      search: true,
    },
    {
      value: "rcDetails",
      subList: [
        { header: "RC Number", value: "identifier", isSelector: true },
        { header: "RC Photo", value: "photo", format: "image" },
        { header: "RC Issue Date", value: "issueDate", format: "date" },
        {
          header: "RC Expiry Date",
          value: "expiryDate",
          custom: checkExpiredDate,
        },
      ],
    },
    {
      value: "tpiDetails",
      subList: [
        { header: "TPI Number", value: "identifier", isSelector: true },
        { header: "TPI Photo", value: "photo", format: "image" },
        { header: "TPI Issue Date", value: "issueDate", format: "date" },
        {
          header: "TPI Expiry Date",
          value: "expiryDate",
          custom: checkExpiredDate,
        },
      ],
    },
    {
      value: "insuranceDetails",
      subList: [
        { header: "Insurance Number", value: "identifier", isSelector: true },
        { header: "Insurance Photo", value: "photo", format: "image" },
        { header: "Insurance Issue Date", value: "issueDate", format: "date" },
        {
          header: "Insurance Expiry Date",
          value: "expiryDate",
          custom: checkExpiredDate,
        },
      ],
    },

    {
      value: "PUCDetails",
      subList: [
        { header: "PUC Number", value: "identifier", isSelector: true },
        { header: "PUC Photo", value: "photo", format: "image" },
        { header: "PUC Issue Date", value: "issueDate", format: "date" },
        {
          header: "PUC Expiry Date",
          value: "expiryDate",
          custom: checkExpiredDate,
        },
      ],
    },

    { header: "Invoice Photo", value: "invoicePhoto", format: "image" },
    { header: "Description", value: "machineDescription" },
    { header: "Action", action: actionButtons },
  ];

  let allMasterTypes = useSelector((state: any) => state.UI.allMasterType);
  const allMachineData = useSelector(
    (state: any) => state?.MACHINE?.allMachineData
  );
  const createMachineData = useSelector(
    (state: any) => state.MACHINE.createMachineData
  );
  const updateMachineData = useSelector(
    (state: any) => state.MACHINE.updateMachineData
  );
  const viewMachineData = useSelector(
    (state: any) => state.MACHINE.viewMachineData
  );
  const deleteMachineDataObj = useSelector(
    (state: any) => state.MACHINE.deleteMachineData
  );

  const [machineTypeList, setMachineTypeList] = React.useState([]);
  const [machine, setMachine] = React.useState(initialFormState);
  const [finalArr, setFinalArr] = React.useState<any>([]);
  const masterArray = ["Machine", "machineStatus"];
  const [machineStatusList, setMachineStatusList] = React.useState([]);

  // -----------for rc image upload--------
  const [rcImg, setRcImg] = React.useState<File | null>();
  const [rcImgName, setRcImgName] = React.useState("");
  // const [rcImgErr, setRcImgErr] = React.useState(false);

  // -----------for tpi image upload--------
  const [tpiImg, setTpiImg] = React.useState<File | null>();
  const [tpiImgName, setTpiImgName] = React.useState("");
  const [tpiImgErr, setTpiImgErr] = React.useState(false);

  // ----------for insurance img upload-------------
  const [insuranceImg, setInsuranceImg] = React.useState<File | null>();
  const [insuranceImgName, setInsuranceImgName] = React.useState("");
  const [insuranceImgErr, setInsuranceImgErr] = React.useState(false);

  // ----------for PUC img upload-------------
  const [PUCImg, setPUCImg] = React.useState<File | null>();
  const [PUCImgName, setPUCImgName] = React.useState("");
  // const [PUCImgErr, setPUCImgErr] = React.useState(false);

  // ----------for invoice img upload-------------
  const [invoiceImg, setInvoiceImg] = React.useState<File | null>();
  const [invoiceImgName, setInvoiceImgName] = React.useState("");
  const [invoiceImgErr, setInvoiceImgErr] = React.useState(false);

  //----------for drawer------------
  const [drawerToggle, setDrawerToggle] = React.useState(false);
  const [drawerData, setDrawerData] = React.useState({
    module: "",
    data: {},
    machineId: "",
  });

  //--------Enlarge Image--------
  const [enlargeImage, setEnlargeImage] = React.useState({
    image: "",
    isOpen: false,
  });

  //-----modal state--------
  const [open, setOpen] = React.useState(false);
  const [modalText, setModalText] = React.useState("");
  const [handleCallData, setHandleCallData] = React.useState({
    data: "",
    action: "",
  });

  const [isEdit, setIsEdit] = React.useState(false);

  //-------For restricting data input---------
  const floatRegex = /^[0-9\b]+[.]{0,1}[0-9\b]{0,4}$/;
  // const numberRegex = /^[0-9\b]+$/;
  const alphaNumbericRegex = /^[a-zA-Z0-9]+$/;

  //-------For displaying loader---------
  const [isLoading, setIsLoading] = React.useState(false);
  const [isLoadingButton, setIsLoadingButton] = React.useState(false);

  const changeResetValue = () => {};

  useEffect(() => {
    loadMachineList();
    // eslint-disable-next-line
  }, []);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return `${date.getFullYear()}-${month}-${day}`;
  };

  useEffect(() => {
    const newMachine = { ...machine };
    if (viewMachineData !== undefined || viewMachineData != null) {
      if (viewMachineData?.number) {
        newMachine.machineNumber = viewMachineData.number;
      }
      newMachine.machineId = viewMachineData?.machineId
        ? viewMachineData.machineId
        : "";
      newMachine.machineType = viewMachineData?.type
        ? viewMachineData.type
        : "";
      newMachine.machineStatus = viewMachineData?.ownership
        ? viewMachineData.ownership
        : "";
      newMachine.ownerName = viewMachineData?.owner
        ? viewMachineData.owner
        : "";
      newMachine.purchaseDate = viewMachineData?.purchasedOrRentedOn
        ? formatDate(viewMachineData.purchasedOrRentedOn)
        : "";
      newMachine.fuelConsumption = viewMachineData?.fuelConsumption
        ? viewMachineData.fuelConsumption
        : "";
      const rcIndex = viewMachineData?.rcDetails
        ? viewMachineData?.rcDetails.length - 1
        : 0;
      newMachine.rcNumber = viewMachineData?.rcDetails
        ? viewMachineData.rcDetails[rcIndex]?.identifier
          ? viewMachineData.rcDetails[rcIndex].identifier
          : ""
        : "";
      newMachine.rcIssueDate = viewMachineData?.rcDetails?.[rcIndex]?.issueDate
        ? formatDate(viewMachineData?.rcDetails?.[rcIndex]?.issueDate)
        : "";
      newMachine.rcExpiryDate = viewMachineData?.rcDetails?.[rcIndex]?.expiryDate
        ? formatDate(viewMachineData?.rcDetails?.[rcIndex]?.expiryDate)
        : "";

      const tpiIndex = viewMachineData?.tpiDetails
        ? viewMachineData?.tpiDetails.length - 1
        : 0;
      newMachine.tpiNumber = viewMachineData?.tpiDetails
        ? viewMachineData.tpiDetails[tpiIndex].identifier
        : "";
      newMachine.tpiIssueDate = viewMachineData?.tpiDetails
        ? formatDate(viewMachineData.tpiDetails[tpiIndex].issueDate)
        : "";
      newMachine.tpiExpiryDate = viewMachineData?.tpiDetails
        ? formatDate(viewMachineData.tpiDetails[tpiIndex].expiryDate)
        : "";

      const insuranceIndex = viewMachineData?.insuranceDetails
        ? viewMachineData?.insuranceDetails.length - 1
        : 0;
      newMachine.insuranceNumber = viewMachineData?.insuranceDetails
        ? viewMachineData.insuranceDetails[insuranceIndex].identifier
        : "";
      newMachine.insuranceIssueDate = viewMachineData?.insuranceDetails
        ? formatDate(viewMachineData.insuranceDetails[insuranceIndex].issueDate)
        : "";
      newMachine.insuranceExpiryDate = viewMachineData?.insuranceDetails
        ? formatDate(
            viewMachineData.insuranceDetails[insuranceIndex].expiryDate
          )
        : "";

      const PUCIndex = viewMachineData?.PUCDetails
        ? viewMachineData?.PUCDetails.length - 1
        : 0;
      newMachine.PUCNumber = viewMachineData?.PUCDetails
        ? viewMachineData.PUCDetails[PUCIndex].identifier
        : "";
      newMachine.PUCIssueDate = viewMachineData?.PUCDetails?.[PUCIndex]?.issueDate
        ? formatDate(viewMachineData?.PUCDetails?.[PUCIndex]?.issueDate)
        : "";
      newMachine.PUCExpiryDate = viewMachineData?.PUCDetails?.[PUCIndex]?.expiryDate
        ? formatDate(viewMachineData?.PUCDetails?.[PUCIndex]?.expiryDate)
        : "";

      newMachine.description = viewMachineData?.machineDescription
        ? viewMachineData.machineDescription
        : "";
      setMachine(newMachine);

      viewMachineData?.rcDetails
        ? viewMachineData?.rcDetails[rcIndex]
          ? viewMachineData?.rcDetails[rcIndex].photo
            ? setRcImg(viewMachineData?.rcDetails[rcIndex].photo)
            : setRcImg(null)
          : setRcImg(null)
        : setRcImg(null);
      viewMachineData?.rcDetails
        ? viewMachineData?.rcDetails[rcIndex]
          ? viewMachineData?.rcDetails[rcIndex].photo
            ? setRcImgName(viewMachineData?.rcDetails[rcIndex].photo)
            : setRcImgName("")
          : setRcImgName("")
        : setRcImgName("");
      viewMachineData?.tpiDetails
        ? viewMachineData?.tpiDetails[tpiIndex]
          ? viewMachineData?.tpiDetails[tpiIndex].photo
            ? setTpiImg(viewMachineData?.tpiDetails[tpiIndex].photo)
            : setTpiImg(null)
          : setTpiImg(null)
        : setTpiImg(null);
      viewMachineData?.tpiDetails
        ? viewMachineData?.tpiDetails[tpiIndex]
          ? viewMachineData?.tpiDetails[tpiIndex].photo
            ? setTpiImgName(viewMachineData?.tpiDetails[tpiIndex].photo)
            : setTpiImgName("")
          : setTpiImgName("")
        : setTpiImgName("");
      viewMachineData?.insuranceDetails
        ? viewMachineData?.insuranceDetails[insuranceIndex]
          ? viewMachineData?.insuranceDetails[insuranceIndex].photo
            ? setInsuranceImg(
                viewMachineData?.insuranceDetails[insuranceIndex].photo
              )
            : setInsuranceImg(null)
          : setInsuranceImg(null)
        : setInsuranceImg(null);
      viewMachineData?.insuranceDetails
        ? viewMachineData?.insuranceDetails[insuranceIndex]
          ? viewMachineData?.insuranceDetails[insuranceIndex].photo
            ? setInsuranceImgName(
                viewMachineData?.insuranceDetails[insuranceIndex].photo
              )
            : setInsuranceImgName("")
          : setInsuranceImgName("")
        : setInsuranceImgName("");

      viewMachineData?.PUCDetails
        ? viewMachineData?.PUCDetails[PUCIndex]
          ? viewMachineData?.PUCDetails[PUCIndex].photo
            ? setPUCImg(viewMachineData?.PUCDetails[PUCIndex].photo)
            : setPUCImg(null)
          : setPUCImg(null)
        : setPUCImg(null);
      viewMachineData?.PUCDetails
        ? viewMachineData?.PUCDetails[PUCIndex]
          ? viewMachineData?.PUCDetails[PUCIndex].photo
            ? setPUCImgName(viewMachineData?.PUCDetails[PUCIndex].photo)
            : setPUCImgName("")
          : setPUCImgName("")
        : setPUCImgName("");

      viewMachineData?.invoicePhoto
        ? setInvoiceImg(viewMachineData.invoicePhoto)
        : setInvoiceImg(null);
      viewMachineData?.invoicePhoto
        ? setInvoiceImgName(viewMachineData.invoicePhoto)
        : setInvoiceImgName("");

      if (drawerData.module !== undefined || drawerData.module !== "") {
        setDrawerData({
          ...drawerData,
          data: viewMachineData[
            `${
              drawerData.module === "PUC"
                ? "PUC"
                : drawerData.module.toLowerCase()
            }Details`
          ],
        });
      }

      setIsEdit(true);
    }
    // eslint-disable-next-line
  }, [viewMachineData]);

  //calling all the types in forEach loop
  useEffect(() => {
    if (masterArray.length > 0) {
      masterArray.forEach((val: any) => {
        dispatch(
          getAllMasterType({
            endPoint: `master-data/get-all-master-types?type=${val}`,
          })
        );
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (allMasterTypes !== undefined) {
      setFinalArr((oldArr: any) => [...oldArr, allMasterTypes.data]);
    }
  }, [allMasterTypes]);

  useEffect(() => {
    loadMachineList();
    // eslint-disable-next-line
  }, [deleteMachineDataObj]);

  //checking for duplicate array in some cases
  useEffect(() => {
    const typeArr: any = [];
    const statusArr: any = [];

    finalArr.forEach((val: any) => {
      if (val?.length > 0) {
        if (val[0].type === "Machine" && typeArr.length < 1) {
          val.forEach((element: any) => {
            typeArr.push(element.title);
          });
        } else if (val[0].type === "machineStatus" && statusArr.length === 0) {
          val.forEach((element: any) => {
            statusArr.push(element.title.toUpperCase());
          });
        }
      }
    });
    setMachineTypeList(typeArr);
    setMachineStatusList(statusArr);

    // eslint-disable-next-line
  }, [finalArr]);

  useEffect(() => {
    loadMachineList();
    handleCancel();
    // eslint-disable-next-line
  }, [createMachineData, updateMachineData]);

  const handleSubmit = () => {
    if (validateData()) {
      setIsLoadingButton(true);
      let imgUri = `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_URL
          : process.env.REACT_APP_PRO_URL
      }/images/`;

      const obj: any = {
        number: machine.machineNumber,
        machineId: machine.machineId,
        fuelConsumption: machine.fuelConsumption,
        type: machine.machineType,
        status: machine.machineStatus,
        ownerName:
          machine.machineStatus.toUpperCase() === "HIRED"
            ? machine.ownerName
            : "",
        purchasedOrRentedOn: machine.purchaseDate,
        rcNumber: machine.rcNumber ? machine?.rcNumber : "",
        rcIssueDate: machine.rcIssueDate ? machine.rcIssueDate : "",
        rcExpiryDate: machine.rcExpiryDate ? machine.rcExpiryDate : "",
        rcPhoto: rcImgName ? ( rcImgName?.indexOf(imgUri) > -1 ? rcImgName : `${imgUri}${rcImgName}`) : "",
        tpiNumber: machine.tpiNumber,
        tpiIssueDate: machine.tpiIssueDate,
        tpiExpiryDate: machine.tpiExpiryDate,
        tpiPhoto:
          tpiImgName?.indexOf(imgUri) > -1
            ? tpiImgName
            : `${imgUri}${tpiImgName}`,
        insuranceNumber: machine.insuranceNumber,
        insuranceIssueDate: machine.insuranceIssueDate,
        insuranceExpiryDate: machine.insuranceExpiryDate,
        insurancePhoto:
          insuranceImgName?.indexOf(imgUri) > -1
            ? insuranceImgName
            : `${imgUri}${insuranceImgName}`,

        PUCNumber: machine?.PUCNumber?machine?.PUCNumber:"",
        PUCIssueDate: machine?.PUCIssueDate ? machine?.PUCIssueDate : "",
        PUCExpiryDate: machine?.PUCExpiryDate ? machine.PUCExpiryDate : "",
        PUCPhoto:
          PUCImgName?.indexOf(imgUri) > -1
            ? PUCImgName
            : `${imgUri}${PUCImgName}`,

        invoicePhoto:
          invoiceImgName?.indexOf(imgUri) > -1
            ? invoiceImgName
            : `${imgUri}${invoiceImgName}`,
        description: machine.description,
      };

      if (isEdit) {
        obj.machine = viewMachineData.id;
        obj.action = "UPDATE";
        obj.machineDescription = machine.description;
        obj.purchasedOrRentedOn = new Date(machine.purchaseDate).toISOString();

        dispatch(
          putMachineData({
            endPoint: "machine",
            data: obj,
          })
        ).then((res) => {
          setIsLoadingButton(false);
        });
      } else {
        dispatch(
          postCreateMachineData({
            endPoint: "machine",
            data: obj,
          })
        ).then((res) => {
          setIsLoadingButton(false);
        });
      }
    }
  };

  const validateData = () => {
    let passed = true;
    let newMachine = { ...machine };
    if (machine.machineType === undefined || machine.machineType === "") {
      newMachine.machineTypeErr = true;
      passed = false;
    }
    if (machine.machineNumber === undefined || machine.machineNumber === "") {
      newMachine.machineNumberErr = true;
      passed = false;
    }
    if (machine.machineId === undefined || machine.machineId === "") {
      newMachine.machineIdErr = true;
      passed = false;
    }
    if (machine.machineStatus === undefined || machine.machineStatus === "") {
      newMachine.machineStatusErr = true;
      passed = false;
    } else if (
      machine.machineStatus.toUpperCase() === "HIRED" &&
      (machine.ownerName === undefined || machine.ownerName === "")
    ) {
      newMachine.ownerNameErr = true;
      passed = false;
    }
    if (machine.purchaseDate === undefined || machine.purchaseDate === "") {
      newMachine.purchaseDateErr = true;
      passed = false;
    }
    if (
      machine.fuelConsumption === undefined ||
      machine.fuelConsumption === ""
    ) {
      newMachine.fuelConsumptionErr = true;
      passed = false;
    }
    if (!isEdit) {
      // if (machine.rcNumber === undefined || machine.rcNumber === "") {
      //   newMachine.rcNumberErr = true;
      //   passed = false;
      // }
      // if (machine.rcIssueDate === undefined || machine.rcIssueDate === "") {
      //   newMachine.rcIssueDateErr = true;
      //   passed = false;
    if (
        machine.rcExpiryDate !== undefined &&
        machine.rcExpiryDate !== "" && machine.rcExpiryDate !==null
      ) {
        let expectedDate = new Date(machine.rcIssueDate);
        let expiryDate = new Date(machine.rcExpiryDate);
        expectedDate.setFullYear(expectedDate.getFullYear() + 15);
        if (expiryDate < expectedDate) {
          newMachine.rcExpiryDateErr = true;
          newMachine.rcExpiryDateErrMsg =
            "RC Expiry Date should be min of 15 years from Issue date";
          passed = false;
        }
      }

      // if (machine.rcExpiryDate === undefined || machine.rcExpiryDate === "") {
      //   newMachine.rcExpiryDateErr = true;
      //   newMachine.rcExpiryDateErrMsg = "";
      //   passed = false;
      // }
      if (machine.tpiNumber === undefined || machine.tpiNumber === "") {
        newMachine.tpiNumberErr = true;
        passed = false;
      }
      if (machine.tpiIssueDate === undefined || machine.tpiIssueDate === "") {
        newMachine.tpiIssueDateErr = true;
        passed = false;
      } else if (
        machine.tpiExpiryDate !== undefined &&
        machine.tpiExpiryDate !== ""
      ) {
        let expectedDate = new Date(machine.tpiIssueDate);
        let expiryDate = new Date(machine.tpiExpiryDate);
        expectedDate.setMonth(expectedDate.getMonth() + 6);
        if (expiryDate < expectedDate) {
          newMachine.tpiExpiryDateErr = true;
          newMachine.tpiExpiryDateErrMsg =
            "TPI Expiry Date should be min of 6 months from Issue date";
          passed = false;
        }
      }
      if (machine.tpiExpiryDate === undefined || machine.tpiExpiryDate === "") {
        newMachine.tpiExpiryDateErr = true;
        newMachine.tpiExpiryDateErrMsg = "";
        passed = false;
      }
      if (
        machine.insuranceNumber === undefined ||
        machine.insuranceNumber === ""
      ) {
        newMachine.insuranceNumberErr = true;
        passed = false;
      }
      if (
        machine.insuranceIssueDate === undefined ||
        machine.insuranceIssueDate === ""
      ) {
        newMachine.insuranceIssueDateErr = true;
        passed = false;
      } else if (
        machine.insuranceExpiryDate !== undefined &&
        machine.insuranceExpiryDate !== ""
      ) {
        let expectedDate = new Date(machine.insuranceIssueDate);
        let expiryDate = new Date(machine.insuranceExpiryDate);
        expectedDate.setFullYear(expectedDate.getFullYear() + 1);
        if (expiryDate < expectedDate) {
          newMachine.insuranceExpiryDateErr = true;
          newMachine.insuranceExpiryDateErrMsg =
            "Insurance Expiry Date should be min of 1 years from Issue date";
          passed = false;
        }
      }
      if (
        machine.insuranceExpiryDate === undefined ||
        machine.insuranceExpiryDate === ""
      ) {
        newMachine.insuranceExpiryDateErr = true;
        newMachine.insuranceExpiryDateErrMsg = "";
        passed = false;
      }

      // if (machine.PUCNumber === undefined || machine.PUCNumber === "") {
      //   // newMachine.PUCNumberErr = true;
      //   passed = false;
      // }
      // if (machine.PUCIssueDate === undefined || machine.PUCIssueDate === "") {
      //   newMachine.PUCIssueDateErr = true;
      //   passed = false;
      // } 
      if (
        machine.PUCExpiryDate !== undefined &&
        machine.PUCExpiryDate !== ""
      ) {
        let expectedDate = new Date(machine.PUCIssueDate);
        let expiryDate = new Date(machine.PUCExpiryDate);
        expectedDate.setFullYear(expectedDate.getFullYear() + 1);
        if (expiryDate < expectedDate) {
          newMachine.PUCExpiryDateErr = true;
          newMachine.PUCExpiryDateErrMsg =
            "PUC Expiry Date should be min of 1 years from Issue date";
          passed = false;
        }
      }
      // if (machine.PUCExpiryDate === undefined || machine.PUCExpiryDate === "") {
      //   newMachine.PUCExpiryDateErr = true;
      //   newMachine.PUCExpiryDateErrMsg = "";
      //   passed = false;
      // }

      // if (rcImg === undefined || rcImg === null) {
      //   // setRcImgErr(true);
      //   passed = false;
      // }
      if (tpiImg === undefined || tpiImg === null) {
        setTpiImgErr(true);
        passed = false;
      }
      if (insuranceImg === undefined || insuranceImg === null) {
        setInsuranceImgErr(true);
        passed = false;
      }

      // if (PUCImg === undefined || PUCImg === null) {
      //   // setPUCImgErr(true);
      //   passed = false;
      // }
    }

    if (invoiceImg === undefined || invoiceImg === null) {
      setInvoiceImgErr(true);
      passed = false;
    }
    setMachine(newMachine);
    return passed;
  };

  const handleCancel = () => {
    setMachine(initialFormState);
    setRcImg(null);
    setRcImgName("");
    // setRcImgErr(false);
    setTpiImg(null);
    setTpiImgName("");
    setTpiImgErr(false);
    setInsuranceImg(null);
    setInsuranceImgName("");
    setInsuranceImgErr(false);

    setPUCImg(null);
    setPUCImgName("");
    // setPUCImgErr(false);

    setInvoiceImg(null);
    setInvoiceImgName("");
    setInvoiceImgErr(false);
    setIsEdit(false);
  };

  const handleEdit = (obj: any) => {
    setHandleCallData({ data: obj.id, action: "EDIT" });
    setModalText(`Are you sure you want to edit this machine?`);
    setOpen(true);
  };

  const handleDelete = (obj: any) => {
    setHandleCallData({ data: obj.id, action: "DELETE" });
    setModalText(`Are you sure you want to delete this machine?`);
    setOpen(true);
  };

  const handleCall = () => {
    setOpen(false);
    if (handleCallData.action.toUpperCase() === "EDIT") {
      requestMachineData(handleCallData.data);
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    } else if (handleCallData.action.toUpperCase() === "DELETE") {
      deleteMachine(handleCallData.data);
    }
    handleCancel();
  };

  const loadMachineList = () => {
    setIsLoading(true);

    dispatch(
      getAllMachineData({
        endPoint: `machine/list`,
      })
    ).then((res) => {
      setIsLoading(false);
    });
  };

  const loadMachineListWithoutLoader = () => {
    dispatch(
      getAllMachineData({
        endPoint: `machine/list`,
      })
    );
  };

  const requestMachineData = (id: any) => {
    dispatch(
      getMachineData({
        endPoint: `machine?id=${id}`,
      })
    );
  };

  const deleteMachine = (id: any) => {
    dispatch(
      deleteMachineData({
        endPoint: `machine?id=${id}`,
      })
    );
  };

  const openDrawer = (module: string, data: any) => {
    const obj: any = {
      module,
      data,
      machineId: viewMachineData.id,
    };
    setDrawerData(obj);
    setDrawerToggle(true);
  };
  //----------------to download data--------------------------------------
  console.log(allMachineData);
  useEffect(() => {
    const downloadData = allMachineData?.map((val: any) => {
      const rcLength = val?.rcDetails.length;
      const tpilength = val?.tpiDetails.length;
      const insuranceLength = val?.insuranceDetails.length;
      const PUCLength = val?.PUCDetails ? val?.PUCDetails?.length : 1;
      const nullRemover = (item: any) => {
        return item === null ? "" : item;
      };
      return {
        "Machine Type": nullRemover(val?.type),
        "Machine ID": nullRemover(val?.machineId),
        "Machine Number": nullRemover(val?.number),
        "Machine Status": nullRemover(val?.ownership),
        "Owner Name": nullRemover(val?.owner),
        "Purchase/Rented Date": nullRemover(val?.assignedOn),
        "Standard Fuel Consumption (Ltr/Hr)": nullRemover(val?.fuelConsumption),
        "RC Number": nullRemover(val?.rcDetails[rcLength - 1]?.identifier),
        "RC Issue Date": formatDate(
          nullRemover(val?.rcDetails[rcLength - 1]?.issueDate)
        ),
        "RC Expiry Date": formatDate(
          nullRemover(val?.rcDetails[rcLength - 1]?.expiryDate)
        ),
        "RC Photo": nullRemover(val?.rcDetails[rcLength - 1]?.photo),
        "TPI Number": nullRemover(val?.tpiDetails[tpilength - 1]?.identifier),
        "TPI Issue Date": formatDate(
          nullRemover(val?.tpiDetails[tpilength - 1]?.issueDate)
        ),
        "TPI Expiry Date": formatDate(
          nullRemover(val?.tpiDetails[tpilength - 1]?.expiryDate)
        ),
        "TPI Photo": nullRemover(val?.tpiDetails[tpilength - 1]?.photo),
        "Insurance Number": nullRemover(
          val?.insuranceDetails[insuranceLength - 1]?.identifier
        ),
        "Insurance Issue Date": formatDate(
          nullRemover(val?.insuranceDetails[insuranceLength - 1]?.issueDate)
        ),
        "Insurance Expiry Date": formatDate(
          nullRemover(val?.insuranceDetails[insuranceLength - 1]?.expiryDate)
        ),
        "Insurance Photo": nullRemover(
          val?.insuranceDetails[insuranceLength - 1]?.photo
        ),

        "PUC Number":
          val?.PUCDetails &&
          nullRemover(val?.PUCDetails[PUCLength - 1]?.identifier),
        "PUC Issue Date":
          val?.PUCDetails &&
          formatDate(nullRemover(val?.PUCDetails[PUCLength - 1]?.issueDate)),
        "PUC Expiry Date":
          val?.PUCDetails &&
          formatDate(nullRemover(val?.PUCDetails[PUCLength - 1]?.expiryDate)),
        "PUC Photo":
          val?.PUCDetails && nullRemover(val?.PUCDetails[PUCLength - 1]?.photo),

        "Invoice Photo": nullRemover(val?.invoicePhoto),
        Description: nullRemover(val?.assignmentDescription),
      };
    });
    setDataToDownload(downloadData);
  }, [allMachineData]);

  return (
    <>
      {isLoading ? (
        <Loader
          color="#5f67e0"
          loading={isLoading}
          size={20}
          height="80vh"
          style={{ width: "inherit" }}
        />
      ) : (
        <Grid container className="mt1">
          <Grid className="bg--white box--shadow mt0 p1">
            <Grid item xs={12} container>
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={18}
                  className="mb1 mt0"
                >
                  <span className="fw500">Add Machine</span>
                </Text>
              </Grid>
            </Grid>
            <Grid container xs={12} spacing={2}>
              {/* ------- Machine Type ------ */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb0 mt0"
                >
                  <span className="fw500">Select Machine Type*</span>
                </Text>
                <SelectBox
                  borderColor={machine?.machineTypeErr ? "danger" : "primary"}
                  data={machineTypeList}
                  placeHolder="Select Machine Type"
                  defaultVal={machine?.machineType}
                  resetVal={machine?.machineType === "" ? true : false}
                  changeReset={changeResetValue}
                  onChange={(e) => {
                    setMachine({
                      ...machine,
                      machineType: e.target.value,
                      machineTypeErr: false,
                    });
                  }}
                />
                <Text
                  type={machine?.machineTypeErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    machine?.machineTypeErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Select Machine Type
                </Text>
              </Grid>

              {/* ------- Machine ID ------ */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt0"
                >
                  <span className="fw500">Machine ID*</span>
                </Text>
                <Input
                  color={machine.machineIdErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  required
                  value={machine.machineId}
                  maxLength={5}
                  type="text"
                  onChange={(e) => {
                    // if (
                    //   e.target.value === "" ||
                    //   numberRegex.test(e.target.value)
                    // ) {
                    console.log("machineId:", e.target.value);
                    setMachine({
                      ...machine,
                      machineId: e.target.value,
                      machineIdErr: false,
                    });
                    // }
                  }}
                />
                <Text
                  type={machine?.machineIdErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    machine?.machineIdErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Enter Machine ID
                </Text>
              </Grid>

              {/* ------- Machine Number ------ */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt0"
                >
                  <span className="fw500">Machine Number*</span>
                </Text>
                <Input
                  color={machine.machineNumberErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  required
                  value={machine.machineNumber}
                  maxLength={10}
                  type="text"
                  onChange={(e) => {
                    if (
                      e.target.value === "" ||
                      alphaNumbericRegex.test(e.target.value)
                    ) {
                      setMachine({
                        ...machine,
                        machineNumber: e.target.value,
                        machineNumberErr: false,
                      });
                    }
                  }}
                />
                <Text
                  type={machine?.machineNumberErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    machine?.machineNumberErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Enter Machine Number
                </Text>
              </Grid>
              {/* -------Machine status------ */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb0 mt1"
                >
                  <span className="fw500">Machine Status*</span>
                </Text>
                <SelectBox
                  data={machineStatusList}
                  placeHolder="Select Machine Status"
                  defaultVal={machine?.machineStatus}
                  resetVal={machine?.machineStatus === "" ? true : false}
                  changeReset={changeResetValue}
                  onChange={(e) => {
                    setMachine({
                      ...machine,
                      machineStatus: e.target.value,
                      machineStatusErr: false,
                    });
                  }}
                  borderColor={machine?.machineStatusErr ? "danger" : "primary"}
                />
                <Text
                  type={machine?.machineStatusErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    machine?.machineStatusErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Select Machine Status
                </Text>
              </Grid>

              {/* ------- Owner Name ------ */}
              {machine.machineStatus.toUpperCase() === "HIRED" && (
                <Grid item xs={4}>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="mb mt1"
                  >
                    <span className="fw500">Owner Name*</span>
                  </Text>
                  <Input
                    color={machine.ownerNameErr ? "danger" : "primary"}
                    fonts="normal"
                    placeholder="Enter Here"
                    required
                    value={machine.ownerName}
                    maxLength={20}
                    type="text"
                    onChange={(e) => {
                      setMachine({
                        ...machine,
                        ownerName: e.target.value,
                        ownerNameErr: false,
                      });
                    }}
                  />
                  <Text
                    type={machine?.ownerNameErr ? "danger" : "normal"}
                    fonts="normal"
                    fontSize={12}
                    className={
                      machine?.ownerNameErr ? "mb0 mt0 float-right" : "d-none"
                    }
                  >
                    Please Enter Owner Name
                  </Text>
                </Grid>
              )}
              {/* -------Purchase Date------ */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt1"
                >
                  <span className="fw500">Purchased/Hire Date*</span>
                </Text>
                <Input
                  color={machine.purchaseDateErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={machine.purchaseDate}
                  type="date"
                  onChange={(e) => {
                    setMachine({
                      ...machine,
                      purchaseDate: e.target.value,
                      purchaseDateErr: false,
                    });
                  }}
                />
                <Text
                  type={machine.purchaseDateErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    machine.purchaseDateErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Enter Purchase Date
                </Text>
              </Grid>
              {/* -------Standard Fuel Consumption------ */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt1"
                >
                  <span className="fw500">
                    Standard Fuel Consumption (Ltr/Hr)*
                  </span>
                </Text>
                <Input
                  color={machine.fuelConsumptionErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  required
                  maxLength={5}
                  value={machine.fuelConsumption}
                  type="text"
                  onChange={(e) => {
                    if (
                      e.target.value === "" ||
                      floatRegex.test(e.target.value)
                    ) {
                      setMachine({
                        ...machine,
                        fuelConsumption: e.target.value,
                        fuelConsumptionErr: false,
                      });
                    }
                  }}
                />
                <Text
                  type={machine?.fuelConsumptionErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    machine?.fuelConsumptionErr
                      ? "mb0 mt0 float-right"
                      : "d-none"
                  }
                >
                  Please Enter Fuel Consumption
                </Text>
              </Grid>
              {/* -------RC Number------ */}
              <Grid item xs={4}>
                <Grid className="d-flex sb">
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="mb mt1 float-left"
                  >
                    <span className="fw500">RC Number</span>
                  </Text>
                  {isEdit && (
                    <Text
                      type="link"
                      fonts="normal"
                      fontSize={14}
                      className="mb mt1 "
                      onTextClick={() =>
                        openDrawer("RC", viewMachineData.rcDetails)
                      }
                    >
                      <span className="fw500">View/Add New/Edit RC</span>
                    </Text>
                  )}
                </Grid>
                <Input
                  color={"primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  required
                  value={machine.rcNumber}
                  maxLength={20}
                  type="text"
                  onChange={(e) => {
                    if (
                      e.target.value === "" ||
                      alphaNumbericRegex.test(e.target.value)
                    ) {
                      setMachine({
                        ...machine,
                        rcNumber: e.target.value,
                        // rcNumberErr: false,
                      });
                    }
                  }}
                  readOnly={isEdit}
                />
                {/* <Text
                  type={machine?.rcNumberErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    machine?.rcNumberErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Enter RC Number
                </Text> */}
              </Grid>

              {/* -------RC Issue Date------ */}
              <Grid item xs={2}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt1"
                >
                  <span className="fw500">RC Issue Date</span>
                </Text>
                <Input
                  color={"primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={machine?.rcIssueDate ? machine?.rcIssueDate : ""}
                  type="date"
                  onChange={(e) => {
                    setMachine({
                      ...machine,
                      rcIssueDate: e.target.value,
                      // rcIssueDateErr: false,
                    });
                  }}
                  readOnly={isEdit}
                />
                <Text
                  type={"normal"}
                  fonts="normal"
                  fontSize={12}
                  className={//machine?.rcIssueDateErr ? "mb0 mt0 float-right" : 
                    "d-none"
                  }
                >
                  Please Select RC Issue Date
                </Text>
              </Grid>
              {/* -------RC Expiry Date------ */}
              <Grid item xs={2}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt1"
                >
                  <span className="fw500">RC Expiry Date</span>
                </Text>
                <Input
                  color={"primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={machine?.rcExpiryDate}
                  min={machine?.rcIssueDate}
                  type="date"
                  onChange={(e) => {
                    setMachine({
                      ...machine,
                      rcExpiryDate: e.target.value,
                      rcExpiryDateErr: false,
                    });
                  }}
                  readOnly={isEdit}
                />
                <Text
                  type={machine?.rcExpiryDateErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    machine?.rcExpiryDateErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  {machine.rcExpiryDateErrMsg
                    ? machine.rcExpiryDateErrMsg
                    : "Please Select RC Expiry Date"}
                </Text>
              </Grid>

              {/* -------TPI Number------ */}
              <Grid item xs={4}>
                <Grid className="d-flex sb">
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="mb mt1 float-left"
                  >
                    <span className="fw500">TPI Number*</span>
                  </Text>
                  {isEdit && (
                    <Text
                      type="link"
                      fonts="normal"
                      fontSize={14}
                      className="mb mt1 "
                      onTextClick={() =>
                        openDrawer("TPI", viewMachineData.tpiDetails)
                      }
                    >
                      <span className="fw500">View/Add New/Edit TPI</span>
                    </Text>
                  )}
                </Grid>
                <Input
                  color={machine?.tpiNumberErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  required
                  value={machine.tpiNumber}
                  maxLength={20}
                  type="text"
                  onChange={(e) => {
                    if (
                      e.target.value === "" ||
                      alphaNumbericRegex.test(e.target.value)
                    ) {
                      setMachine({
                        ...machine,
                        tpiNumber: e.target.value,
                        tpiNumberErr: false,
                      });
                    }
                  }}
                  readOnly={isEdit}
                />
                <Text
                  type={machine?.tpiNumberErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    machine?.tpiNumberErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Enter TPI Number
                </Text>
              </Grid>

              {/* -------TPI Issue Date------ */}
              <Grid item xs={2}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt1"
                >
                  <span className="fw500">TPI Issue Date*</span>
                </Text>
                <Input
                  color={"primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={machine?.tpiIssueDate}
                  type="date"
                  onChange={(e) => {
                    setMachine({
                      ...machine,
                      tpiIssueDate: e.target.value,
                      tpiIssueDateErr: false,
                    });
                  }}
                  readOnly={isEdit}
                />
                <Text
                  type={machine?.tpiIssueDateErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    machine?.tpiIssueDateErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  Please Select TPI Issue Date
                </Text>
              </Grid>

              {/* -------TPI Expiry Date------ */}
              <Grid item xs={2}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt1"
                >
                  <span className="fw500">TPI Expiry Date*</span>
                </Text>
                <Input
                  color={"primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={machine?.tpiExpiryDate}
                  min={machine?.tpiIssueDate}
                  type="date"
                  onChange={(e) => {
                    setMachine({
                      ...machine,
                      tpiExpiryDate: e.target.value,
                      tpiExpiryDateErr: false,
                    });
                  }}
                  readOnly={isEdit}
                />
                <Text
                  type={machine?.tpiExpiryDateErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    machine?.tpiExpiryDateErr ? "mb0 mt0 float-right" : "d-none"
                  }
                >
                  {machine.tpiExpiryDateErrMsg
                    ? machine.tpiExpiryDateErrMsg
                    : "Please Select TPI Expiry Date"}
                </Text>
              </Grid>

              {/* -------Insurance Number------ */}
              <Grid item xs={4}>
                <Grid className="d-flex sb">
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="mb mt1 float-left"
                  >
                    <span className="fw500">Insurance Number*</span>
                  </Text>
                  {isEdit && (
                    <Text
                      type="link"
                      fonts="normal"
                      fontSize={14}
                      className="mb mt1"
                      onTextClick={() =>
                        openDrawer(
                          "Insurance",
                          viewMachineData.insuranceDetails
                        )
                      }
                    >
                      <span className="fw500">View/Add New/Edit Insurance</span>
                    </Text>
                  )}
                </Grid>
                <Input
                  color={machine?.insuranceNumberErr ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  required
                  value={machine.insuranceNumber}
                  maxLength={20}
                  type="text"
                  onChange={(e) => {
                    if (
                      e.target.value === "" ||
                      alphaNumbericRegex.test(e.target.value)
                    ) {
                      setMachine({
                        ...machine,
                        insuranceNumber: e.target.value,
                        insuranceNumberErr: false,
                      });
                    }
                  }}
                  readOnly={isEdit}
                />
                <Text
                  type={machine?.insuranceNumberErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    machine?.insuranceNumberErr
                      ? "mb0 mt0 float-right"
                      : "d-none"
                  }
                >
                  Please Enter Insurance Number
                </Text>
              </Grid>

              {/* -------Insurance Issue Date------ */}
              <Grid item xs={2}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt1"
                >
                  <span className="fw500">Insurance Issue Date*</span>
                </Text>
                <Input
                  color={"primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={machine?.insuranceIssueDate}
                  type="date"
                  onChange={(e) => {
                    setMachine({
                      ...machine,
                      insuranceIssueDate: e.target.value,
                      insuranceIssueDateErr: false,
                    });
                  }}
                  readOnly={isEdit}
                />
                <Text
                  type={machine?.insuranceIssueDateErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    machine?.insuranceIssueDateErr
                      ? "mb0 mt0 float-right"
                      : "d-none"
                  }
                >
                  Please Select Insurance Issue Date
                </Text>
              </Grid>

              {/* -------Insurance Expiry Date------ */}
              <Grid item xs={2}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt1"
                >
                  <span className="fw500">Insurance Expiry Date*</span>
                </Text>
                <Input
                  color={"primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={machine?.insuranceExpiryDate}
                  min={machine?.insuranceIssueDate}
                  type="date"
                  onChange={(e) => {
                    setMachine({
                      ...machine,
                      insuranceExpiryDate: e.target.value,
                      insuranceExpiryDateErr: false,
                    });
                  }}
                  readOnly={isEdit}
                />
                <Text
                  type={machine?.insuranceExpiryDateErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    machine?.insuranceExpiryDateErr
                      ? "mb0 mt0 float-right"
                      : "d-none"
                  }
                >
                  {machine.insuranceExpiryDateErrMsg
                    ? machine.insuranceExpiryDateErrMsg
                    : "Please Select Insurance Expiry Date"}
                </Text>
              </Grid>

              {/* -------PUC Number------ */}
              <Grid item xs={4}>
                <Grid className="d-flex sb">
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="mb mt1 float-left"
                  >
                    <span className="fw500">PUC Number</span>
                  </Text>
                  {isEdit && (
                    <Text
                      type="link"
                      fonts="normal"
                      fontSize={14}
                      className="mb mt1"
                      onTextClick={() =>
                        openDrawer("PUC", viewMachineData.PUCDetails)
                      }
                    >
                      <span className="fw500">View/Add New/Edit PUC</span>
                    </Text>
                  )}
                </Grid>
                <Input
                  color={"primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  required
                  value={machine.PUCNumber}
                  maxLength={20}
                  type="text"
                  onChange={(e) => {
                    if (
                      e.target.value === "" ||
                      alphaNumbericRegex.test(e.target.value)
                    ) {
                      setMachine({
                        ...machine,
                        PUCNumber: e.target.value,
                      });
                    }
                  }}
                  readOnly={isEdit}
                />
              </Grid>

              {/* -------PUC Issue Date------ */}
              <Grid item xs={2}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt1"
                >
                  <span className="fw500">PUC Issue Date</span>
                </Text>
                <Input
                  color={"primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={machine?.PUCIssueDate}
                  type="date"
                  onChange={(e) => {
                    setMachine({
                      ...machine,
                      PUCIssueDate: e.target.value,
                      // PUCIssueDateErr: false,
                    });
                  }}
                  readOnly={isEdit}
                />
              </Grid>

              {/* -------PUC Expiry Date------ */}
              <Grid item xs={2}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt1"
                >
                  <span className="fw500">PUC Expiry Date</span>
                </Text>
                <Input
                  color={"primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={machine?.PUCExpiryDate}
                  min={machine?.PUCIssueDate}
                  type="date"
                  onChange={(e) => {
                    setMachine({
                      ...machine,
                      PUCExpiryDate: e.target.value,
                      // PUCExpiryDateErr: false,
                    });
                  }}
                  readOnly={isEdit}
                />
              </Grid>

              <Grid item xs={12} container>
                {/* --------RC photo------- */}
                <Grid item xs={2}>
                  {!isEdit && (
                    <>
                      <ImageInputComponent
                        title="RC Photo"
                        setValue={setRcImg}
                        setImageName={setRcImgName}
                        value={rcImg}
                        bind="rcImg"
                        // required={true}
                        // setErr={setRcImgErr}
                        isEdit={isEdit}
                        imageChanged={false}
                      />

                      {/* <Text
                        type={rcImgErr ? "danger" : "normal"}
                        fonts="normal"
                        fontSize={12}
                        className={rcImgErr ? "mb0 mt0" : "d-none"}
                      >
                        Please upload Photo
                      </Text> */}
                    </>
                  )}
                  {isEdit && rcImg && (
                    <>
                      <Text
                        type="normal"
                        fonts="normal"
                        fontSize={16}
                        className="mb mt1"
                      >
                        <span className="fw500">RC Photo</span>
                      </Text>
                      <Grid className="file_upload_box ml-1" item>
                        <img
                          src={rcImgName}
                          alt="..."
                          className="list-photo pointer p"
                          onClick={() => {
                            setEnlargeImage({
                              ...enlargeImage,
                              image: rcImgName,
                              isOpen: true,
                            });
                          }}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
                {/* --------TPI photo------- */}
                <Grid item xs={2}>
                  {!isEdit && (
                    <>
                      <ImageInputComponent
                        title="TPI Photo"
                        setValue={setTpiImg}
                        setImageName={setTpiImgName}
                        value={tpiImg}
                        bind="tpiImg"
                        required={true}
                        setErr={setTpiImgErr}
                        isEdit={false}
                        imageChanged={false}
                      />
                      <Text
                        type={tpiImgErr ? "danger" : "normal"}
                        fonts="normal"
                        fontSize={12}
                        className={tpiImgErr ? "mb0 mt0" : "d-none"}
                      >
                        Please upload Photo
                      </Text>
                    </>
                  )}
                  {isEdit && tpiImg && (
                    <>
                      <Text
                        type="normal"
                        fonts="normal"
                        fontSize={16}
                        className="mb mt1"
                      >
                        <span className="fw500">TPI Photo</span>
                      </Text>
                      <Grid className="file_upload_box ml-1" item>
                        <img
                          src={tpiImgName}
                          alt="..."
                          className="list-photo pointer p"
                          onClick={() => {
                            setEnlargeImage({
                              ...enlargeImage,
                              image: tpiImgName,
                              isOpen: true,
                            });
                          }}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
                {/* --------Insurance photo------- */}
                <Grid item xs={2}>
                  {!isEdit && (
                    <>
                      <ImageInputComponent
                        title="Insurance Photo"
                        setValue={setInsuranceImg}
                        setImageName={setInsuranceImgName}
                        value={insuranceImg}
                        bind="insuranceImg"
                        required={true}
                        setErr={setInsuranceImgErr}
                        isEdit={isEdit}
                        imageChanged={false}
                      />

                      <Text
                        type={insuranceImgErr ? "danger" : "normal"}
                        fonts="normal"
                        fontSize={12}
                        className={insuranceImgErr ? "mb0 mt0" : "d-none"}
                      >
                        Please upload Photo
                      </Text>
                    </>
                  )}
                  {isEdit && insuranceImg && (
                    <>
                      <Text
                        type="normal"
                        fonts="normal"
                        fontSize={16}
                        className="mb mt1"
                      >
                        <span className="fw500">Insurance Photo</span>
                      </Text>
                      <Grid className="file_upload_box ml-1" item>
                        <img
                          src={insuranceImgName}
                          alt="..."
                          className="list-photo pointer p"
                          onClick={() => {
                            setEnlargeImage({
                              ...enlargeImage,
                              image: insuranceImgName,
                              isOpen: true,
                            });
                          }}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>

                {/* --------PUC photo------- */}
                <Grid item xs={2}>
                  {!isEdit && (
                    <>
                      <ImageInputComponent
                        title="PUC Photo"
                        setValue={setPUCImg}
                        setImageName={setPUCImgName}
                        value={PUCImg}
                        bind="PUCImg"
                        // required={true}
                        // setErr={setPUCImgErr}
                        isEdit={isEdit}
                        imageChanged={false}
                      />

                      {/* <Text
                        type={"normal"}
                        fonts="normal"
                        fontSize={12}
                        className={PUCImgErr ? "mb0 mt0" : "d-none"}
                      >
                        Please upload Photo
                      </Text> */}
                    </>
                  )}
                  {isEdit && PUCImg && (
                    <>
                      <Text
                        type="normal"
                        fonts="normal"
                        fontSize={16}
                        className="mb mt1"
                      >
                        <span className="fw500">PUC Photo</span>
                      </Text>
                      <Grid className="file_upload_box ml-1" item>
                        <img
                          src={PUCImgName}
                          alt="..."
                          className="list-photo pointer p"
                          onClick={() => {
                            setEnlargeImage({
                              ...enlargeImage,
                              image: PUCImgName,
                              isOpen: true,
                            });
                          }}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>

                {/* --------Invoice photo------- */}
                <Grid item xs={2}>
                  <ImageInputComponent
                    title="Invoice Photo"
                    setValue={setInvoiceImg}
                    setImageName={setInvoiceImgName}
                    value={invoiceImg}
                    bind="invoiceImg"
                    required={true}
                    setErr={setInvoiceImgErr}
                    isEdit={isEdit}
                    imageChanged={false}
                  />
                  <Text
                    type={invoiceImgErr ? "danger" : "normal"}
                    fonts="normal"
                    fontSize={12}
                    className={invoiceImgErr ? "mb0 mt0" : "d-none"}
                  >
                    Please upload Photo
                  </Text>
                </Grid>
              </Grid>

              <Grid item xs={12} container spacing={2}>
                {/* -------Description------ */}
                <Grid item xs={4}>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="mb mt1"
                  >
                    <span className="fw500">Description</span>
                  </Text>
                  <TextArea
                    placeholder="Write description here"
                    value={machine.description}
                    onChange={(e) =>
                      setMachine({ ...machine, description: e.target.value })
                    }
                  />
                </Grid>
              </Grid>

              {/* -------Buttons------ */}
              <Grid item xs={12} container>
                <Grid className="submit_button mt1 mb1">
                  <Button
                    category="primary"
                    icon="delete"
                    onClick={handleSubmit}
                    type="button"
                    isRounded={true}
                  >
                    {isLoadingButton ? (
                      <Loader
                        color="#fff"
                        loading={isLoadingButton}
                        size={8}
                        height="auto"
                      />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Grid>
                <Grid className="cancel_button mt1 mb1 ml-1">
                  <Button
                    category="border-only"
                    icon="delete"
                    onClick={handleCancel}
                    type="button"
                    isRounded={true}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {allMachineData && (
            <List
              listData={allMachineData}
              fields={fields}
              title={"Added Machine List"}
              dataToDownload={dataToDownload}
              isOverflow
            />
          )}
          {/* ---------------Enlarge Image Modal---------- */}
          <EnlargeImage modalData={enlargeImage} />
          {
            /* -------modal---- */
            <Grid item xs={12}>
              <Modal
                image="modalImage"
                call={() => {
                  handleCall();
                }}
                reset={() => {
                  setOpen(false);
                }}
                openModal={open}
                title={`${modalText}`}
                showImageModal={false}
              />
            </Grid>
          }
          {viewMachineData && (
            <Drawer
              anchor={"right"}
              open={drawerToggle}
              onClose={() => setDrawerToggle(false)}
            >
              <AddMachineDrawer
                drawerData={drawerData}
                toggleDrawer={setDrawerToggle}
                reloadData={(id: any) => {
                  requestMachineData(id);
                  loadMachineListWithoutLoader();
                }}
              />
            </Drawer>
          )}
        </Grid>
      )}
    </>
  );
};

export default AddMachine;
